export function isGcisPaymentSetToDisable() {
    //@ts-ignore
    return window?.WFP_CONFIG?.DISABLE_ALL_GCIS_PAYMENT;
}
